module.exports = __webpack_public_path__ + "img/liondesk-marketing-logo.1f3c3aa1.png";